import { MaskLine, Reveal } from "../components/Reveal";
import { STATEMENT } from "../data/content";

export default function StatementSection() {
  return (
    <section className="bg-[#0a0a0a] text-white" data-testid="statement-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-40">
        <div className="grid md:grid-cols-12 gap-8 md:gap-10 items-end">
          <Reveal className="md:col-span-8">
            <h2 className="font-display font-medium tracking-tighter leading-[0.92] text-5xl sm:text-6xl md:text-8xl">
              <MaskLine delay={0.05}>{STATEMENT.lineTop}</MaskLine>
              <MaskLine delay={0.18} className="text-neutral-600">{STATEMENT.lineBottom}</MaskLine>
            </h2>
          </Reveal>
          <Reveal delay={0.2} className="md:col-span-4">
            <p className="text-lg md:text-xl text-neutral-400 leading-relaxed">{STATEMENT.body}</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
